export const VOTE = 'voter/VOTE';
export const QUESTION_VOTE = 'voter/QUESTION_VOTE';
export const QUESTION_ANSWER = 'voter/QUESTION_ANSWER';
export const GET_CLIENT = 'voter/GET_CLIENT';
export const LOAD_DATA = 'voter/LOAG_DATA';
export const SEND_FORM = 'voter/SEND_FORM';
export const FORM_SUCCESS = 'voter/FORM_SUCCESS';
export const FORM_ERROR = 'voter/FORM_ERROR';


// WEBPACK FOOTER //
// ./src/constants/index.js